import { render, staticRenderFns } from "./GExamDetailReportSetting.vue?vue&type=template&id=394d1068&scoped=true&"
import script from "./GExamDetailReportSetting.vue?vue&type=script&lang=ts&"
export * from "./GExamDetailReportSetting.vue?vue&type=script&lang=ts&"
import style0 from "./GExamDetailReportSetting.vue?vue&type=style&index=0&id=394d1068&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394d1068",
  null
  
)

export default component.exports